module.exports = __webpack_public_path__ + "img/license-icon.9e25d310.svg";